import { SVGProps } from "react";

type SvgProps = SVGProps<SVGSVGElement>;

export const SmallTriangleWarning = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M15.76 12.0665L9.49334 1.51984C9.18001 0.986504 8.62667 0.666504 8.00001 0.666504C7.37334 0.666504 6.82001 0.986504 6.51334 1.51984L0.240005 12.0665C-0.0733285 12.6132 -0.0733285 13.2598 0.240005 13.7998C0.553338 14.3398 1.11334 14.6665 1.73334 14.6665H14.2733C14.9 14.6665 15.46 14.3398 15.7667 13.7998C16.0733 13.2598 16.0733 12.6132 15.76 12.0665ZM14.6133 13.1332C14.58 13.1932 14.48 13.3265 14.2733 13.3265H1.72667C1.52 13.3265 1.42 13.1865 1.38667 13.1332C1.35334 13.0798 1.28667 12.9198 1.38667 12.7398L7.66001 2.19317C7.76 2.01984 7.93334 1.99984 8.00001 1.99984C8.06667 1.99984 8.23334 2.01984 8.34001 2.19984L14.6067 12.7465C14.7133 12.9198 14.64 13.0798 14.6067 13.1398L14.6133 13.1332ZM7.33334 5.33317H8.66667V9.33317H7.33334V5.33317ZM7.33334 10.6665H8.66667V11.9998H7.33334V10.6665Z"
      fill="currentColor"
    />
  </svg>
);
